import { fetchEventPage, type EventPage } from './fetchEventPage'

/**
 * Query params for the team-wide event list.
 *
 * The window and sort the GAMES request is already using, so the two lists stay
 * bounded alike.
 *
 * These are sent, where an earlier fetch-everything call sent none: a complete
 * list could be windowed and sorted once it arrived, but a PAGED stream cannot
 * — you can only sort what you have already pulled — so the server has to
 * return the pages in display order.
 *
 * Every field is optional: an absent key means "no filter", which is not the
 * same as sending an empty one.
 */
export interface ListTeamEventsQuery {
  starts_after?: string
  starts_before?: string
  order?: string
  per_page?: number
}

/**
 * ONE page of a team's events across EVERY season, plus any competition events
 * it has been named in. Backs the "All Seasons" selection, where there is no
 * single roster to scope to.
 *
 * Errors throw, like every other event service.
 */
export const listTeamEventsPage = (
  teamId: string,
  query: ListTeamEventsQuery = {},
  page = 1
): Promise<EventPage> => fetchEventPage(`/teams/${teamId}/events`, query, page)
